import {
  Alert,
  Button,
  ButtonGroup,
  Grid,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { Box, Container } from "@mui/system";
import React, { useEffect, useRef, useState } from "react";
import RemovalTab from "../../components/common/RemovalTab";
import LeadList from "../components/LeadList";
import PageInfoTitle from "../../components/pageTitle/PageInfoTitle";
import LeadCardDetails from "../components/lead/LeadCardDetails";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  getAllLeadLogListAction,
  getSingleLeadAction,
  setUpdateLeadAction,
} from "../../store/reducers/leadSlice";
import {
  getNotificationMessageAction,
  setNotificationAction,
} from "../../store/reducers/mmymSlice";
import LeadFormDetails from "../components/lead/LeadFormDetails";
import ManageLogs from "../components/lead/ManageLogs";
import LeadLogList from "../components/lead/LeadLogList";
import ManageLeadsPage from "../components/manageLeads/ManageLeadsPage";
import ManageConfirmation from "../components/lead/confirmation/ManageConfirmation";
import {
  getConfirmationNotificationAction,
  updateConfirmationToolTipAction,
} from "../../store/reducers/clientConfirmationSlice";
import ManageSmsTemplate from "../components/smsTemplate/ManageSmsTemplate";
import ManageEmailTemplate from "../components/emailTemplate/ManageEmailTemplate";
import ManageJobView from "../components/jobPrint/ManageJobView";
import useStyles from "../components/lead/confirmation/confirmationStyle";
import ManageProfessionalConfirmation from "../components/IsProfessional/confirmation/ManageProfessionalConfirmation";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import refreshIcon from "../../assets/svg/refresh.svg";
import AlertPopup from "../../components/common/alertPopup/AlertPopup";
import {
  customerResendCustomerLike,
  setCustomerResendCustomerResponse,
} from "../../store/reducers/customerSlice";
import Loader from "../../components/common/loader/Loader";
import AlertCheckStorageModal from "../components/storage/components/AlertCheckStorageModal";
import { checkCustomerStorageAction, clearCustomerStorageCheckResponse, setCreateContractResponseAction } from "../../store/reducers/contractStorageSlice";
import { setUpdateSurveySummaryAction } from "../../store/reducers/leadSurveySlice";

const ClientAdminRemovals = () => {
  const dispatch = useDispatch();

  const [generateId, setGenerateId] = useState<string | null>(null);
  const { isResetCustomerLinkResponse } = useSelector(
    (state: any) => state.customer,
  );
  const { editClientOriginalData } = useSelector(
    (state: any) => state.adminClients,
  );
  const { leadDetails, isUpdateLeadSuccess } = useSelector(
    (state: any) => state.lead,
  );
  const { response, } = useSelector((state: any) => state.storage);
  const { isCompleteSurveyedSummarySuccess, isSurveySummarySuccess } = useSelector(
    (state: any) => state.leadSurvey,
  );

  const { user, notificationModulePermission, userProfile, permissions } =
    useSelector((state: any) => state?.user);
  const { toolTipResponse } = useSelector((state: any) => state?.confirmation);
  const { isCreateContractResponse } = useSelector(
    (state: any) => state.contractStorage,
  );
  const [isLoader, setIsLoader] = useState(true);
  const [isProfessionalSection, setIsProfessionalSection] = useState(
    userProfile?.features?.includes("Professional Financial") || false, // Safe fallback
  );

  useEffect(() => {
    setIsProfessionalSection(
      userProfile?.features?.includes("Professional Financial") || false,
    ); // Sync profile changes
  }, [userProfile]);

  useEffect(() => {
    if (
      generateId ||
      isUpdateLeadSuccess ||
      isCompleteSurveyedSummarySuccess || isSurveySummarySuccess ||
      response?.addStorage || isCreateContractResponse
    ) {
      dispatch(getSingleLeadAction(generateId));
      dispatch(setUpdateLeadAction(false));
      dispatch(setUpdateSurveySummaryAction(false));
      dispatch(setCreateContractResponseAction(false));
      if (
        !response?.addStorage &&
        (isUpdateLeadSuccess ||
          isCompleteSurveyedSummarySuccess ||
          isSurveySummarySuccess ||
          isCreateContractResponse)
      ) {
        setCheckStorageModal(false);
      }
      // ❌ Don't call getClientForEditAction if ANY of the success flags is true
      const shouldSkipClientFetch =
        isUpdateLeadSuccess || isCompleteSurveyedSummarySuccess || isSurveySummarySuccess;
      if (
        !shouldSkipClientFetch &&
        (notificationModulePermission?.read ||
          user?.user?.roles?.includes("Owner") ||
          user?.user?.roles?.includes("TENANT"))
      ) {
        dispatch(getNotificationMessageAction());
        dispatch(getConfirmationNotificationAction());
      }
    }
  }, [
    dispatch,
    generateId,
    isUpdateLeadSuccess,
    isCompleteSurveyedSummarySuccess,
    response?.addStorage,isCreateContractResponse,isSurveySummarySuccess
  ]);

  useEffect(() => {
    return () => {
      dispatch(setNotificationAction({ message: [], severity: "error" }));
    };
  }, []);

  const [isSectionChangeUserInitiated, setIsSectionChangeUserInitiated] =
    useState(false);
  const [activeSection, setActiveSection] = useState<"leads" | "logs">("logs");
  const manageLeadsRef = useRef<HTMLDivElement>(null);
  const manageLogsRef = useRef<HTMLDivElement>(null);
  const [jobViewOpen, setJobViewOpen] = useState(false);
  const [jobViewType, setJobViewType] = useState("");
  const [isSmsTemplate, setIsSmsTemplate] = useState(false);
  const [isEmailTemplate, setIsEmailTemplate] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isResendCustomer, setIsResendCustomer] = useState(false);
  const [checkStorageModal, setCheckStorageModal] = useState(false);
  const handleOpen = (e: any) => setAnchorEl(e.currentTarget);

  useEffect(() => {
    if (isSectionChangeUserInitiated) {
      if (activeSection === "leads") {
        manageLeadsRef.current?.scrollIntoView({ behavior: "smooth" });
      } else if (activeSection === "logs") {
        manageLogsRef.current?.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [activeSection, isSectionChangeUserInitiated]);

  const handleManageLeadsClick = () => {
    setIsSectionChangeUserInitiated(true);
    setActiveSection("leads");
    if (user?.user?.roles?.includes("Surveyor")) {
      manageLeadsRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleManageLogsClick = () => {
    setIsSectionChangeUserInitiated(true);
    setActiveSection("logs");
  };

  const [confirmationModel, setConfirmationModel] = useState(false);
  const classes = useStyles({ confirmationModel });

  const handleConfirmation = () => {
    setConfirmationModel(true);
    if (
      toolTipResponse?.isSeen === false &&
      toolTipResponse?.isNewResponse === true
    ) {
      dispatch(updateConfirmationToolTipAction(generateId));
    }
  };
  const [isAdmin, setIsAdmin] = useState<null | boolean>(null);
  const [isConfirmation, setIsConfirmation] = useState<boolean | null>(null);

  useEffect(() => {
    if (leadDetails || user) {
      setIsAdmin(
        user?.user?.roles?.includes("TENANT") ||
          user?.user?.roles?.includes("Admin") ||
          user?.user?.roles?.includes("Owner")
          ? true
          : false,
      );
      setIsConfirmation(
        leadDetails?.lead?.status === "CONFIRMED" ||
          leadDetails?.lead?.status === "JOB" ||
          leadDetails?.lead?.status === "COMPLETED"
          ? false
          : true,
      );
    }
  }, [leadDetails, user]);

  const handleClose = () => {
    setConfirmationModel(false);
    setJobViewOpen(false);
    setAnchorEl(null);
  };

  const onClickSMSTemplate = () => {
    setIsSmsTemplate(true);
  };

  const onClickEmailTemplate = () => {
    setIsEmailTemplate(true);
  };

  const onClickPrintJobSheet = () => {
    setJobViewOpen(true);
  };

  const handleResendCustomerLink = () => {
    setIsResendCustomer(true);
  };

  const handleCloseAlert = () => {
    setIsResendCustomer(false);
    setCheckStorageModal(false);
    dispatch(clearCustomerStorageCheckResponse());
    dispatch(setCreateContractResponseAction(false));
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  const handleSendCustomerLink = () => {
    dispatch(
      customerResendCustomerLike({
        customer_id: leadDetails?.lead?.customer_id,
      }),
    );
  };

  useEffect(() => {
    if (leadDetails?.lead?.generated_id) {
      setIsLoader(false);
    }
  }, [leadDetails]);

  useEffect(() => {
    if (isResetCustomerLinkResponse) {
      dispatch(setCustomerResendCustomerResponse(false));
      handleCloseAlert();
    }
  }, [dispatch, isResetCustomerLinkResponse]);

  const quoteButton = (
    <>
      <ButtonGroup
        variant="contained"
        sx={{
          height: "30px",
          marginLeft: "10px",
          "& .MuiButton-root": {
            height: "30px",
            fontSize: "13px",
            textTransform: "capitalize",
            padding: "0 10px",
            minWidth: "auto",
          },
        }}
      >
        <Button
          onClick={() => {
            onClickPrintJobSheet();
            setJobViewType("DEFAULT");
          }}
        >
          Print
        </Button>

        <Button
          sx={{
            minWidth: "28px",
            width: "28px",
            padding: 0,
          }}
          onClick={handleOpen}
        >
          <ArrowDropDownIcon sx={{ fontSize: "18px" }} />
        </Button>
      </ButtonGroup>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            onClickPrintJobSheet();
            setJobViewType("BOX_COLLECTION");
          }}
        >
          Box Collection Sheet
        </MenuItem>
        <MenuItem
          onClick={() => {
            onClickPrintJobSheet();
            setJobViewType("MATERIAL");
          }}
        >
          Fragile Move Packing Material Sheet
        </MenuItem>
        <MenuItem
          onClick={() => {
            onClickPrintJobSheet();
            setJobViewType("STORAGE_JOB");
          }}
        >
          From Storage Job Sheet
        </MenuItem>
        <MenuItem
          onClick={() => {
            onClickPrintJobSheet();
            setJobViewType("STORAGE");
          }}
        >
          Storage Bingo Sheet
        </MenuItem>
        <MenuItem
          onClick={() => {
            onClickPrintJobSheet();
            setJobViewType("RESIDENCE_CONTENT");
          }}
        >
          Residence and Contents Sheet
        </MenuItem>
        <MenuItem
          onClick={() => {
            onClickPrintJobSheet();
            setJobViewType("LOAD_DATE_JOB_SHEET");
          }}
        >
          Load Date Job Sheet
        </MenuItem>
        <MenuItem
          onClick={() => {
            onClickPrintJobSheet();
            setJobViewType("INTO_STORE_JOB_SHEET");
          }}
        >
          Into Store Job Sheet
        </MenuItem>
        <MenuItem
          onClick={() => {
            onClickPrintJobSheet();
            setJobViewType("FULL_PACK");
          }}
        >
          Full Pack Job Sheet
        </MenuItem>
        <MenuItem
          onClick={() => {
            onClickPrintJobSheet();
            setJobViewType("PACKING_CHECK_SHEET");
          }}
        >
          Full Pack Check Sheet
        </MenuItem>
      </Menu>
    </>
  );

  const handleCheckStorage = () => {
    setCheckStorageModal(true);
    // if (leadDetails?.lead?.generated_id) {
    //   dispatch(
    //     checkCustomerStorageAction({ leadId: leadDetails?.lead?.generated_id }),
    //   );
    // }
  };

  // useEffect(() => {
  //   if (customerStorageResponse) {
  //     console.log("customerStorageResponse", customerStorageResponse);
  //     if (customerStorageResponse?.existingCustomerFound) {
  //     } else {
  //       setCheckStorageModal(true);
  //     }
  //   }
  // }, [customerStorageResponse]);

  return (
    <>
      {isLoader && <Loader />}
      {checkStorageModal && (
        <AlertCheckStorageModal
          open={checkStorageModal}
          setCheckStorageModal={setCheckStorageModal}
          onHide={handleCloseAlert}
          submitHandler={() => {}}
        />
      )}
      {isResendCustomer && (
        <AlertPopup
          open={isResendCustomer}
          onHide={handleCloseAlert}
          title={"Alert"}
          content={"Are you sure you want to resend customer link ?"}
          submitHandler={handleSendCustomerLink}
        />
      )}
      {jobViewOpen && (
        <ManageJobView
          open={jobViewOpen}
          jobViewType={jobViewType}
          surveyId={leadDetails?.lead?.survey_id}
          onHide={handleClose}
          title={
            jobViewType === "MOVE_DATE"
              ? "Move Date Sheet"
              : jobViewType === "BOX_COLLECTION"
                ? "Box Collection Sheet"
                : jobViewType === "MATERIAL"
                  ? "FragileMove Packing Material Sheet"
                  : jobViewType === "STORAGE_JOB"
                    ? "From Storage Job Sheet"
                    : jobViewType === "WAGES"
                      ? "Wage Sign Off"
                      : jobViewType === "STORAGE"
                        ? "Storage Bingo Sheet"
                        : jobViewType === "RESIDENCE_CONTENT"
                          ? "Residence and Contents Sheet"
                          : jobViewType === "LOAD_DATE_JOB_SHEET"
                            ? "Load Date Job Sheet"
                            : jobViewType === "INTO_STORE_JOB_SHEET"
                              ? "Into Store Job Sheet"
                              : "Move Date Sheet"
          }
        />
      )}
      {isSmsTemplate && (
        <ManageSmsTemplate
          open={isSmsTemplate}
          onHide={() => setIsSmsTemplate(false)}
          setSelectedTemplate={() => {}}
          title="Choose SMS template"
        />
      )}

      {isEmailTemplate && (
        <ManageEmailTemplate
          open={isEmailTemplate}
          onHide={() => setIsEmailTemplate(false)}
          setSelectedTemplate={() => {}}
          title="Choose Email template"
        />
      )}

      {confirmationModel && (
        <section
          className={confirmationModel ? classes.estimatePopupOverlay : ""}
        >
          {isProfessionalSection ? (
            <>
              <ManageProfessionalConfirmation
                generateId={generateId}
                show={confirmationModel}
                setShow={setConfirmationModel}
                //  title="Confirmation"
              />
            </>
          ) : (
            <>
              <ManageConfirmation
                generateId={generateId}
                show={confirmationModel}
                setShow={setConfirmationModel}
                //  title="Confirmation"
              />
            </>
          )}
        </section>
      )}
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        sx={{ background: "#f4f4f4" }}
      >
        <Grid item xs={12} md={3}>
          {/* <Container
            maxWidth="md"
            sx={{ bgcolor: "#fff", padding: "10px 2px !important" }}
          > */}
          <Box
            sx={{
              // bgcolor: "#fff",
              height: { xs: "auto", md: "100vh" },
              // border: "1px solid #d1cfcf",
              // borderRadius: "5px",
              // padding: "4px",
            }}
          >
            <LeadList setGenerateId={setGenerateId} />
          </Box>
          {/* </Container> */}
        </Grid>
        <Grid item xs={12} md={9}>
          <Container
            maxWidth="xl"
            sx={{
              paddingLeft: "0px !important",
              paddingRight: "0px !important",
            }}
          >
            <Box
              sx={{
                height: { xs: "auto", md: "100vh" },
                // border: "1px solid #d1cfcf",
                // borderRadius: "5px",
                paddingLeft: "0px !important",
                paddingRight: "0px !important",
                // padding: "0px 16px",
                overflow: "scroll",
              }}
            >
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  bgcolor: "#fff",
                  zIndex: 1,
                  border: "1px solid #C4CDD5",
                }}
              >
                <PageInfoTitle
                  title=""
                  desc={
                    <>
                      {leadDetails?.lead?.generated_id && (
                        <>Ref No. {leadDetails?.lead?.generated_id}</>
                      )}

                      {!editClientOriginalData?.transport_code &&
                        !leadDetails?.lead?.generated_id && (
                          <Alert severity="warning">
                            You'll need to add the details in order to proceed.
                          </Alert>
                        )}
                    </>
                  }
                  leadId={leadDetails?.lead?.generated_id}
                  actionComponent={
                    isProfessionalSection &&
                    (isAdmin || permissions?.["Lead"]?.read)
                      ? leadDetails?.lead?.status === "COMPLETED" ||
                        !leadDetails?.lead?.generated_id
                        ? ""
                        : leadDetails?.lead?.status === "NEW LEAD" ||
                            leadDetails?.lead?.status === "ESTIMATES" ||
                            leadDetails?.lead?.status === "SURVEY" ||
                            leadDetails?.lead?.status === "JOB" ||
                            leadDetails?.lead?.status === "QUOTE" ||
                            leadDetails?.lead?.status === "CONFIRMED" ||
                            leadDetails?.lead?.status === "PROVISIONAL" ||
                            leadDetails?.lead?.status === "AWAITING"
                          ? quoteButton
                          : ""
                      : ""
                  }
                  onClickPrintJobSheet={onClickPrintJobSheet}
                  isPrint={
                    isProfessionalSection
                      ? false
                      : isAdmin || permissions?.["Lead"]?.read
                        ? leadDetails?.lead?.status === "COMPLETED" ||
                          !leadDetails?.lead?.generated_id
                          ? false
                          : leadDetails?.lead?.status === "SURVEY" ||
                              leadDetails?.lead?.status === "JOB" ||
                              leadDetails?.lead?.status === "QUOTE" ||
                              leadDetails?.lead?.status === "CONFIRMED"
                            ? true
                            : false
                        : false
                  }
                  onClickSMSTemplate={onClickSMSTemplate}
                  isEmail={
                    isAdmin ||
                    permissions?.["Communication: Email"]?.read ||
                    permissions?.["Communication:Email"]?.read
                      ? leadDetails?.lead?.status === "STORAGE" || !leadDetails?.lead?.generated_id 
                        ? false
                        : true
                      : false
                  }
                  onClickEmailTemplate={onClickEmailTemplate}
                  isText={
                    isAdmin ||
                    permissions?.["Communication: SMS"]?.read ||
                    permissions?.["Communication:SMS"]?.read
                      ? leadDetails?.lead?.status === "COMPLETED" || leadDetails?.lead?.status === "STORAGE" ||
                        !leadDetails?.lead?.generated_id
                        ? false
                        : true
                      : false
                  }
                  // button={isAdmin ? `Confirmation` : ""}
                  // button1={
                  //   user?.user?.role === "Surveyor"
                  //     ? "Manage Survey"
                  //     : activeSection === "leads"
                  //       ? "Manage Logs"
                  //       : isAdmin
                  //         ? "Manage Leads"
                  //         : "Manage Survey"
                  // }
                  disabled1={leadDetails?.lead?.generated_id ? false : true}
                  disabled={
                    leadDetails?.lead?.status === "CONFIRMED" ||
                    leadDetails?.lead?.status === "JOB" ||
                    leadDetails?.lead?.status === "COMPLETED"
                      ? false
                      : true
                  }
                  // onClick={handleConfirmation}
                  onClickButton1={
                    user?.user?.roles?.includes("Surveyor")
                      ? leadDetails?.lead?.generated_id
                        ? handleManageLeadsClick
                        : undefined
                      : activeSection === "leads"
                        ? leadDetails?.lead?.generated_id
                          ? handleManageLogsClick
                          : undefined
                        : leadDetails?.lead?.generated_id
                          ? handleManageLeadsClick
                          : undefined
                  }
                  disabled3={leadDetails?.lead?.generated_id ? false : true}
                  button3={
                    leadDetails?.lead?.status !== "STORAGE" &&
                    leadDetails?.lead?.status !== "DEBTOR" &&
                    leadDetails?.lead?.status !== "EXTERNAL" &&
                    (isAdmin || permissions?.["Lead"]?.read)
                      ? "Resend Customer Link"
                      : ""
                  }
                  onClickButton3={handleResendCustomerLink}
                  buttons={
                    leadDetails?.lead?.generated_id &&
                    !["NEW LEAD", "ESTIMATES", "QUOTE", "SURVEY", "STORAGE", "COMPLETED"].includes(
                      leadDetails?.lead?.status,
                    )
                      ? [
                          {
                            title: "Move Into Storage",
                            onClick: handleCheckStorage,
                          },
                        ]
                      : []
                  }
                />
                <RemovalTab leadDetails={leadDetails} />
              </Box>
              <LeadCardDetails leadDetails={leadDetails} />
              <Box
                sx={{
                  bgcolor: "#fff",
                  height: { xs: "auto" },
                  border: "1px solid #d1cfcf",
                  borderRadius: "5px",
                  overflow: "hidden",
                  // padding: "10px",
                  padding: "10px 0px !important",
                }}
              >
                <>
                  {leadDetails?.lead && leadDetails?.lead?.generated_id ? (
                    <>
                      <LeadFormDetails leadDetails={leadDetails} />
                    </>
                  ) : (
                    <center>
                      <Typography sx={{ color: "#4A4A4A" }}>
                        No Record Found!
                      </Typography>
                    </center>
                  )}
                </>
              </Box>
              {leadDetails?.lead?.status !== "STORAGE ENQ" && (
                  <Box
                    sx={{
                      bgcolor: "#fff",
                      height: { xs: "auto" },
                      border: "1px solid #d1cfcf",
                      borderRadius: "5px",
                      marginTop: "10px",
                      padding: "0px 10px 10px 10px !important",
                    }}
                  >
                    <Typography
                      sx={{
                        textTransform: "capitalize !important",
                        padding: "10px 0px",
                        fontWeight: 800,
                        color: "#333333",
                        fontSize: "16px",
                      }}
                      variant="subtitle1"
                    >
                      Manage Lead
                    </Typography>

                    {leadDetails?.lead?.generated_id && (
                      <>
                        <ManageLeadsPage
                          isDisabledConfirmation={isAdmin ? false : true}
                          onButtonClick={handleConfirmation}
                        />
                        <div ref={manageLeadsRef} />
                      </>
                    )}
                  </Box>
                )}

              {!(
                user?.user?.roles?.length === 1 &&
                user?.user?.roles[0] === "Surveyor"
              ) &&
                leadDetails?.lead?.generated_id && (
                  <Box
                    sx={{
                      bgcolor: "#fff",
                      height: { xs: "auto" },
                      border: "1px solid #d1cfcf",
                      borderRadius: "5px",
                      marginTop: "10px",
                      padding: "10px !important",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        sx={{
                          textTransform: "capitalize !important",
                          padding: "0px",
                          fontWeight: 800,
                          color: "#333333",
                          fontSize: "16px",
                        }}
                        variant="subtitle1"
                      >
                        Logs
                      </Typography>
                      <Tooltip title="Refresh logs" placement="left">
                        <IconButton
                          size="small"
                          aria-label="Refresh logs"
                          onClick={() => {
                            // Call the log list API directly
                            if (leadDetails?.lead?.generated_id) {
                              dispatch(
                                getAllLeadLogListAction({
                                  page: 1,
                                  limit: 10,
                                  orderBy: "created_at",
                                  orderIn: "DESC",
                                  leadId: leadDetails.lead.generated_id,
                                }),
                              );
                            }
                          }}
                          sx={{ ml: 1 }}
                        >
                          <img
                            src={refreshIcon}
                            alt="refresh"
                            style={{ width: 20, height: 20 }}
                          />
                        </IconButton>
                      </Tooltip>
                    </Box>

                    {/* {leadDetails?.lead?.status !== "COMPLETED" && ( */}
                    <ManageLogs leadId={leadDetails?.lead?.generated_id} />
                    {/* )} */}

                    {leadDetails?.lead?.generated_id && (
                      <LeadLogList leadId={generateId} />
                    )}

                    <div ref={manageLogsRef} />
                  </Box>
                )}
            </Box>
          </Container>
        </Grid>
      </Grid>
    </>
  );
};
export default ClientAdminRemovals;
